import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadGeographyListBegin, loadGeographyListFailed, loadGeographyListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* loadGeographyList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_MDS_URL}/geography/geographies`;
    yield put(loadGeographyListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK && data?.geographies) {
      const res = {
        data: data.geographies,
        meta: data.meta,
      };
      yield put(loadGeographyListSuccessful(res));
      yield call(resolveActionPromise(action, data.geographies));
    } else {
      yield put(loadGeographyListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadGeographyListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
